/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Field } from 'redux-form'
import { MAX_LENGTHS } from 'constants/forms'
import { Text, GetTextPath } from 'hocs/localization'
import { Input } from 'apps/FormFields'
import Button from 'elements/Button'
import {
  hasRequired,
  createValidation,
  createValidator,
  hasValidPassword,
  hasPasswordUppercaseLetters,
  hasPasswordLowercaseLetters,
  hasPasswordSpecialCharacters,
  hasPasswordNumbers,
  hasPasswordValidLength,
} from 'utils/form'
import { FIELD_NAMES } from './constants'
import * as styles from './ChangePasswordForm.scss'

interface IProps {
  isDisabled?: boolean,
  t: Text,
  getTextPath: GetTextPath,
  handleSubmit: any,
  submitting: boolean,
  valid: boolean,
  isUserUnableToUpdateInfo: boolean,
}

class ChangePasswordForm extends React.Component<IProps, {}> {
  private requiredFieldValidation = createValidation([
    createValidator(hasRequired, this.props.getTextPath('errors.textField')),
  ])

  public passwordValidation = createValidation([
    createValidator(hasValidPassword, this.props.getTextPath('errors.password')),
    createValidator(hasPasswordUppercaseLetters, this.props.getTextPath('errors.password.uppercaseLetter')),
    createValidator(hasPasswordLowercaseLetters, this.props.getTextPath('errors.password.lowercaseLetter')),
    createValidator(hasPasswordNumbers, this.props.getTextPath('errors.password.number')),
    createValidator(hasPasswordSpecialCharacters, this.props.getTextPath('errors.password.specialCharacter')),
    createValidator(hasPasswordValidLength, this.props.getTextPath('errors.password.length')),
  ])

  public render () {
    const {
      t,
      handleSubmit,
      submitting,
      valid,
      isUserUnableToUpdateInfo,
    } = this.props

    const isFieldDisabled = submitting || isUserUnableToUpdateInfo

    return (
      <form className={styles.root} onSubmit={handleSubmit}>
        <div className={styles.row}>
          <div className={styles.fieldWrap}>
            <Field
              label={t('currentPasswordLabel')}
              type='password'
              name={FIELD_NAMES.currentPassword}
              component={Input}
              size='large'
              disabled={isFieldDisabled}
              validate={this.requiredFieldValidation}
              maxLength={MAX_LENGTHS.password}
              newLineError
              required
            />
          </div>
          <div className={styles.fieldWrap}>
            <Field
              label={t('newPasswordLabel')}
              type='password'
              name={FIELD_NAMES.newPassword}
              component={Input}
              disabled={isFieldDisabled}
              validate={this.passwordValidation}
              maxLength={MAX_LENGTHS.password}
              newLineError
              withPrompt
              withError='newPasswordMatch'
              required
            />
          </div>
        </div>
        {!isUserUnableToUpdateInfo && (
          <div className={styles.submitButton}>
            <Button fluid disabled={submitting || !valid}>
              {submitting ? t('saveButtonSubmitting') : t('saveButton')}
            </Button>
          </div>
        )}
      </form>
    )
  }
}

export default ChangePasswordForm
